export default "__VITE_PUBLIC_ASSET__3d993d9a__"